var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('products-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var campaign = ref.campaign;
    var proposal = ref.proposal;
    var proposalStep = ref.proposalStep;
    var loadedProducts = ref.loadedProducts;
    var preselectedProducts = ref.preselectedProducts;
    var exitConfirmationRequired = ref.exitConfirmationRequired;
    var loadCheckoutUrlProducts = ref.loadCheckoutUrlProducts;
    var patchProposalStep = ref.patchProposalStep;
    var goPreviousStep = ref.goPreviousStep;
    var goNextStep = ref.goNextStep;
    var isLoading = ref.isLoading;
    var isLoadingCheckoutUrl = ref.isLoadingCheckoutUrl;
    var removeProduct = ref.removeProduct;
    var isCompletingProposal = ref.isCompletingProposal;
    var errorMessage = ref.errorMessage;
    var errors = ref.errors;
    var checkOutUrlErrorMessage = ref.checkOutUrlErrorMessage;
    var loadProductUrl = ref.loadProductUrl;
return [_c('proposal-products-view',{attrs:{"campaign":campaign,"proposal":proposal,"proposal-step":proposalStep,"products":loadedProducts,"preselected-products":preselectedProducts,"is-loading":isLoading,"is-loading-checkout-url":isLoadingCheckoutUrl,"is-completing-proposal":isCompletingProposal,"error-message":errorMessage,"errors":errors,"check-out-url-error-message":checkOutUrlErrorMessage,"exit-confirmation-required":exitConfirmationRequired},on:{"remove-product":removeProduct,"checkout-products":loadCheckoutUrlProducts,"load-product-url":loadProductUrl,"go-next-step":goNextStep,"go-previous-step":goPreviousStep,"patch-step":patchProposalStep}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }